var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnChatwithus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 3.25H15.1666C17.4651 3.25 19.6695 4.16309 21.2948 5.78841C22.9201 7.41372 23.8332 9.61812 23.8332 11.9167C23.8332 14.2152 22.9201 16.4196 21.2948 18.0449C19.6695 19.6702 17.4651 20.5833 15.1666 20.5833V24.375C9.74991 22.2083 2.16656 18.9583 2.16656 11.9167C2.16656 9.61812 3.07966 7.41372 4.70497 5.78841C6.33029 4.16309 8.5347 3.25 10.8332 3.25ZM12.9999 18.4167H15.1666C16.0202 18.4167 16.8654 18.2485 17.654 17.9219C18.4426 17.5952 19.1592 17.1164 19.7628 16.5129C20.3663 15.9093 20.8451 15.1927 21.1718 14.4041C21.4984 13.6155 21.6666 12.7703 21.6666 11.9167C21.6666 11.0631 21.4984 10.2178 21.1718 9.42922C20.8451 8.64061 20.3663 7.92405 19.7628 7.32047C19.1592 6.71689 18.4426 6.23811 17.654 5.91145C16.8654 5.58479 16.0202 5.41667 15.1666 5.41667H10.8332C9.10933 5.41667 7.45603 6.10149 6.23705 7.32047C5.01806 8.53946 4.33324 10.1928 4.33324 11.9167C4.33324 15.8275 7.0004 18.3798 12.9999 21.1033V18.4167Z",
    fill: "#488DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChatwithus);
export default __webpack_public_path__ + "static/media/icn_chat with us.5fad097ca9ebacbb5bff07ca6ccfc43b.svg";
export { ForwardRef as ReactComponent };